import React from 'react'
import {getWebsitePublications_website_publications} from '@data/queries/components/__generated__/getWebsitePublications'
import Container from '@packages/justo-parts/lib/components/Container'

import List from './List'

import styles from './styles.module.css'

export default function Publications(props: {
  ssrPublications?: getWebsitePublications_website_publications
}) {
  return (
    <div className={styles.container}>
      <Container>
        <List ssrPublications={props.ssrPublications} />
      </Container>
    </div>
  )
}
